/**
 * Has this browser ever been enrolled?
 *
 * The real device cookie is HttpOnly, so the page cannot read it, which is the point. The
 * server sets a second cookie next to it carrying nothing but the fact of enrollment, and
 * the login screen uses that to decide whether to offer the PIN. The server still checks
 * the real cookie; a forged hint gets an operator a PIN box that will refuse them.
 */
export const DEVICE_HINT_COOKIE = 'ops_device_hint';

export function hasDeviceHint(cookieString: string = document.cookie): boolean {
  return cookieString
    .split(';')
    .map((part) => part.trim())
    .some((part) => part === `${DEVICE_HINT_COOKIE}=1`);
}
